<template>
  <v-app>
    <dashboard-core-app-bar />

    <dashboard-core-drawer />

    <dashboard-core-view />

  </v-app>
</template>

<script>
  export default {
    name: 'DashboardIndex',

    components: {
      DashboardCoreAppBar: () => import('@/views/core/AppBar'),
      DashboardCoreDrawer: () => import('@/views/core/Drawer'),
      DashboardCoreView: () => import('@/views/core/View'),
    },

    data: () => ({
      expandOnHover: false,
    }),
  }
</script>
